import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import SelectorComponent from "components/SelectorComponents";
import DateRangePicker from "components/DateRangePicker";

const FilterBar = ({
  classes,
  filterOptions,
  customFilterOptions,
  endComponent,
  startComponent,
}) => {
  const renderFilterOptions = () =>
    filterOptions.map((filterOption, index) => {
      return (
        <div key={index} className={classes.wrapper}>
          {index > 0 && <div className={classes.divider} />}
          {filterOption.type === "selector" && (
            <SelectorComponent
              optionValue={filterOption.optionValue}
              placeholder={filterOption.placeholder}
              searchPlaceHolder={filterOption.searchPlaceHolder}
              onChange={filterOption.onChange}
              multiple={filterOption.multiple}
              singleSelect={filterOption.singleSelect}
              value={filterOption.value}
              selectAllText={filterOption.selectAllText}
              getCustomLabel={filterOption.getCustomLabel}
              disableSearch={filterOption.disableSearch}
              disableAllSelect={filterOption.disableAllSelect}
              width={filterOption.width}
              height={filterOption.height}
            />
          )}
          {filterOption.type === "dateRange" && (
            <DateRangePicker
              timezoneOffset={filterOption.timezoneOffset}
              value={filterOption.value}
              position={filterOption.position}
              handleApply={filterOption.handleApply}
            />
          )}
        </div>
      );
    });

  const renderCustomFilterOptions = () => (
    <>
      <div className={classes.divider} />
      {customFilterOptions}
    </>
  );

  return (
    <div className={classes.root}>
      <div className={classes.flexBox}>
        {startComponent}
        {!!filterOptions && renderFilterOptions()}
        {!!customFilterOptions && renderCustomFilterOptions()}
      </div>
      <div>{endComponent}</div>
    </div>
  );
};

const styles = {
  root: {
    background: "white",
    border: "1px solid #DADADA",
    height: 52,
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
  },
  divider: {
    width: 1,
    height: 24,
    margin: "0px 20px",
    background: "#DADADA",
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
  },
};

export default withStyles(styles)(FilterBar);
